import { OwlDateTimeModule } from '@danielmoncada/angular-datetime-picker'
import { OwlMomentDateTimeModule } from '@danielmoncada/angular-datetime-picker-moment-adapter'
import { FormsModule, ReactiveFormsModule } from '@angular/forms'
import { ModuleWithProviders, NgModule } from '@angular/core'
import { NgSelectModule } from '@ng-select/ng-select'
import { CommonModule, NgOptimizedImage } from '@angular/common'
import { RouterModule } from '@angular/router'

/* Modules */
import { NgbModule } from '@ng-bootstrap/ng-bootstrap'
import { IconsModule } from '@modules/icons/icons.module'

/* Others */
import * as appComponents from '../../components/index'

/* Containers */
import * as appCommonContainers from './containers'

/* Components */
import * as appCommonComponents from './components'

/* Directives */
import * as appCommonDirectives from './directives'

/* Services */
import * as appCommonServices from './services'

/* Pipes */
import { NgxMaskPipe, NgxMaskDirective } from 'ngx-mask'

const modules = [IconsModule, NgbModule]

@NgModule({
    imports: [
        ...modules,
        CommonModule,
        RouterModule,
        FormsModule,
        NgxMaskPipe,
        NgSelectModule,
        NgxMaskDirective,
        NgOptimizedImage,
        OwlDateTimeModule,
        ReactiveFormsModule,
        OwlMomentDateTimeModule
    ],
    declarations: [
        ...appComponents.components,
        ...appCommonContainers.containers,
        ...appCommonComponents.components,
        ...appCommonDirectives.directives,
    ],
    exports: [
        ...appComponents.components,
        ...appCommonContainers.containers,
        ...appCommonComponents.components,
        ...appCommonDirectives.directives,
        ...modules
    ]
})
export class AppCommonModule {
    static forRoot(): ModuleWithProviders<AppCommonModule> {
        return {
            ngModule: AppCommonModule,
            providers: [
                ...appCommonServices.services,
                {
                    provide: 'window',
                    useValue: window
                }
            ]
        }
    }
}
